import { Button } from "@volca/ui/components/ui/button";
import { PageHeader } from "@volca/ui/components/ui/page-components";
import type { ApDocumentType } from "@/accounts-payable/types";
import { documentTypeLabel } from "@/accounts-payable/utils";
import { extractErrorMessage } from "@/core/api/errors";
import { DocumentReviewSkeleton } from "./document-review-skeleton";

export const DocumentReviewFallback = ({
  documentType,
  loading,
  error,
  retrying,
  onRetry,
}: {
  documentType: ApDocumentType;
  loading: boolean;
  error: unknown;
  retrying: boolean;
  onRetry: () => void;
}) => {
  const { capitalized: title, lower } = documentTypeLabel(documentType);
  if (loading) return <DocumentReviewSkeleton />;
  if (!error || extractErrorMessage(error).status === 404)
    return <PageHeader title={title} description={`${title} not found.`} />;
  return (
    <PageHeader
      title={title}
      description={`Couldn't load the ${lower}. Please try again.`}
      actions={
        <Button
          variant="outline"
          disabled={retrying}
          loading={retrying}
          onClick={onRetry}
        >
          Try again
        </Button>
      }
    />
  );
};
